const serviceData = {

    categories : [
                    {
                      id: 1,
                      title: 'Équipements biomédicaux',
                      shortDesc: "Des équipements biomédicaux fiables, certifiés et performants pour les professionnels de santé.",
                      longDesc: "ORTÉGA fournit une large gamme d’équipements biomédicaux répondant aux normes internationales. Nous accompagnons les structures de santé et les professionnels dans le choix, l’installation et la maintenance de dispositifs fiables et durables, garantissant performance, sécurité et conformité aux exigences du secteur médical.",
                      img: './img/img-4.png',
                      size: 'col-lg-6',
                      bg: '#e5e8eb'
                    },
                    {
                    id: 2,
                    title: 'Équipements informatiques',
                    shortDesc: "Des solutions informatiques performantes pour entreprises et administrations.",
                    longDesc: "ORTÉGA propose une large gamme d’équipements informatiques adaptés aux besoins des entreprises et administrations. Cela inclut les ordinateurs, serveurs, caméras de surveillance, équipements de téléphonie, routeurs, switchs et points d’accès (APs). Nous assurons la fourniture, l’installation et le suivi pour garantir des systèmes fiables, sécurisés et optimisés pour la productivité et la continuité de vos activités.",
                    img: './img/psd-3.png',
                    size: 'col-lg-6',
                    bg: '#f1f2e9'
                    },
                    {
                      id: 3,
                      title: 'Services de maintenance',
                      shortDesc: "Une maintenance proactive et réactive pour garantir la performance de vos équipements.",
                      longDesc: "ORTÉGA assure la maintenance préventive et corrective de tous vos équipements biomédicaux, informatiques et de bureau. Nos techniciens qualifiés interviennent rapidement pour minimiser les interruptions et maximiser la durée de vie de vos installations, avec un suivi rigoureux et un support disponible 7j/7.",
                      img: './img/psd-1.png',
                      size: 'col-lg-12',
                      bg: '#faf1f2'
                    },
                    {
                      id: 4,
                      title: 'Logiciels professionnels',
                      shortDesc: "Des logiciels sur mesure pour optimiser la gestion et la productivité de votre entreprise.",
                      longDesc: "ORTÉGA développe et déploie des solutions logicielles personnalisées adaptées aux besoins des entreprises et des professionnels de santé. Nos logiciels permettent de gérer efficacement les opérations, de suivre les performances et d’automatiser les processus, tout en garantissant sécurité, fiabilité et évolutivité.",
                      img: './img/psd-2.png',
                      size: 'col-lg-6',
                      bg: '#e8edf1'
                    },
                    {
                      id: 5,
                      title: 'Mobilier de bureau et papeterie',
                      shortDesc: "Du mobilier ergonomique et fonctionnel pour des espaces de travail modernes.",
                      longDesc: "ORTÉGA propose une gamme complète de mobilier de bureau et de fournitures adaptées aux environnements professionnels. Nos produits combinent confort, durabilité et design moderne pour créer des espaces de travail optimisés, agréables et conformes aux normes ergonomiques.",
                      img: './img/psd-8.png',
                      size: 'col-lg-6',
                      bg: '#f9f9f9'
                    }

                 ],

    services :   [
                    { id: 1, 
                      title: 'Équipements biomédicaux' 
                    },
                    { id: 2, 
                      title: 'Équipements informatiques' 
                    },
                    { id: 3, 
                      title: 'Services de maintenance' 
                    },
                    { id: 4, 
                      title: 'Logiciels professionnels' 
                    },
                 ],


}


export default serviceData;